import HeaderLogo from '@/components/HeaderLogo'
import Stepper from '@/components/Stepper'
import Box from '@mui/material/Box'

const FullStepHeader = () => {
    return <Box
    component={'header'}
    className='flex w-full md:px-10 px-5 pt-6'
  >
    <Box className='h-full w-full w-2/5'>
      <HeaderLogo />
    </Box>
    <Box className='hidden md:flex w-full w-4/5'>
      <Stepper />
    </Box>
  </Box>
}

export default FullStepHeader